/**
 * Rectangle Utils
 */
import { getWindow } from "../utils"

export type Rect = {
  top: number
  left: number
  height: number
  width: number
}

const toClientRect = (rect: Rect): ClientRect => ({
  ...rect,
  right: rect.left + rect.width,
  bottom: rect.top + rect.height
})

const getViewportRect = (element: Node) => {
  const win = getWindow(element)
  return {
    top: 0,
    left: 0,
    height: win.innerHeight,
    width: win.innerWidth
  }
}

export { getViewportRect, toClientRect }
